module.exports = __webpack_public_path__ + "img/traffic_failed.d051d6fb.png";